import React from 'react';
import PropTypes from 'prop-types';
import Question from '../../common/Question';
import TextAreaInput from '../../common/TextAreaInput';
import DocumentUpload from '../../DocumentUpload';
import './SummaryTab.scss';
function SummaryTab(_ref) {
  var proposal = _ref.proposal,
    onFormChange = _ref.onFormChange,
    errors = _ref.errors,
    bio = _ref.bio,
    viewResumeUrl = _ref.viewResumeUrl,
    uploadResumeUrl = _ref.uploadResumeUrl,
    userId = _ref.userId,
    csrfToken = _ref.csrfToken,
    resume = _ref.resume;
  return /*#__PURE__*/React.createElement("div", {
    className: "responsibilities-tab"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 summary"
  }, /*#__PURE__*/React.createElement(Question, {
    title: "1. Provide a brief summary of your experience related to this project.",
    location: "proposal-edit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-4 ms-4 summary-input-container"
  }, /*#__PURE__*/React.createElement(TextAreaInput, {
    formKey: "about_consultant",
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('about_consultant', val);
    },
    errors: errors,
    textAreaPrompt: "We've fetched this content from your bio. Please edit to make it relevant to this project.",
    textPromptClass: !proposal.about_consultant && 'with-error-text',
    placeholder: null,
    value: proposal.about_consultant || bio
  })))), /*#__PURE__*/React.createElement("div", {
    className: "resume-section mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-class-2 medium-weight mb-3"
  }, "2. Resume"), /*#__PURE__*/React.createElement("div", {
    className: "ms-4"
  }, /*#__PURE__*/React.createElement(DocumentUpload, {
    buttonStyle: "button",
    prompt: "Upload Resume",
    viewDocumentUrl: viewResumeUrl,
    uploadDocumentUrl: uploadResumeUrl,
    userId: userId,
    documentType: "resume",
    location: "proposal-edit",
    csrfToken: csrfToken,
    document: resume,
    proposalResourceId: proposal.resource_id,
    saveOnUpload: true
  }))));
}
SummaryTab.propTypes = {
  proposal: PropTypes.shape({}).isRequired,
  onFormChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
  bio: PropTypes.string.isRequired,
  viewResumeUrl: PropTypes.string.isRequired,
  uploadResumeUrl: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  resume: PropTypes.shape({}).isRequired
};
export default SummaryTab;